import type { ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { MsalProvider } from "@azure/msal-react";
import { Toaster } from "react-hot-toast";
import { queryClient } from "@/lib/queryClient";
import { msalClient } from "@/features/auth/authClient";

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <MsalProvider instance={msalClient}>
      <QueryClientProvider client={queryClient}>
        {children}
        <Toaster position="top-right" />
      </QueryClientProvider>
    </MsalProvider>
  );
}
